var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm2.32 13.56c-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-2.49-2.49c-.59-.59-.59-1.54 0-2.13l2.49-2.49c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L7.64 12l2.49 2.5c.29.29.29.77 0 1.06zm4.8-.01c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 0 1 0-1.06L16.36 12l-2.49-2.5a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2.49 2.49c.59.59.59 1.55 0 2.13l-2.49 2.49z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldScroll);
export default __webpack_public_path__ + "static/media/vuesax-bold-scroll.46977564abdec4a4f69df159c38c6096.svg";
export { ForwardRef as ReactComponent };